import React, { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CenterDialogModal({
  open,
  handleClose,
  message,
  type,
}) {
  useEffect(() => {
    let timer = setInterval(() => {
      handleClose();
    }, 5000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      className={`bringFront`}
    >
      <DialogTitle id="alert-dialog-slide-title" className={`${type}-dialog`}>
        {message}
      </DialogTitle>
    </Dialog>
  );
}
